import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import adaLogo from '../ada-logo.svg';
import './HomePage.css';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem('access_token')) {
      navigate('/analyze', { replace: true });
    }
  }, [navigate]);
  return (
    <div className="home-container dark-tech-bg">
      <header className="home-header">
        <img src={adaLogo} alt="ADA Logo" className="home-logo" />
        <h1 className="home-title">AI Document Analyzer</h1>
        <p className="home-subtitle">Your private, AI-powered assistant for document understanding and Q&A.</p>
      </header>
      <section className="home-hero">
        <h2 className="hero-title">Welcome to the future of document intelligence</h2>
        <p className="hero-desc">Upload, search, and ask questions about your documents with blazing speed and privacy. <br/> ADA brings AI-powered insights to your files, all in a beautiful, secure interface.</p>
        <div className="home-actions">
          <Link to="/login" className="home-btn">Sign In</Link>
          <Link to="/register" className="home-btn secondary">Register</Link>
        </div>
      </section>
      <footer className="home-footer">
        <span>Made with <span role="img" aria-label="chip">💻</span> and passion for technology.</span><br/>
        <span>&copy; {new Date().getFullYear()} ADA. All rights reserved.</span>
      </footer>
    </div>
  );
};

export default HomePage;